import { useEffect, useRef, useState } from "react";
import React from "react";
// import isNull from "../../../utils/NullChecking";
import styles from './../SuperSearch.module.css'
// import NotificationHandler from "../../../utils/NotificationHandler";
// import AmountFormatter from "../../../utils/AmountFormatter";
import { useSelector } from "react-redux";
// import HandleStatus from "../HandleStatus";
// import InitialLetters from "../../../utils/InitialLetters";
// import { isMale, isFemale } from "../../../utils/Gender";
// import ContentReceiver from "../../MenuLayout/ContentReceiverNewBrowserTab/ContentReceiver";
// import { GeneralDropDowns } from "../../../actions/GeneralPatientActions";
import { useDispatch } from "react-redux";
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest";
import { enumUtil } from "../../../../utils/Enum";
import isNull from "../../../../utils/NullChecking";
import NotificationHandler from "../../../../utils/NotificationHandler";
import HandleStatus from "../../HandleStatus";
import useHandleOpenNewBrowserTab from "../../NewTabBrowser/useHandleOpenNewBrowserTab";

const SuperSearchSingleClient = (props) => {

    const [openTab, setOpenTab] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [noResult, setNoResult] = useState(false);
    const [noResponse, setnoResponse] = useState(false);
    const inputRef = useRef(null);
    const myDivRef = useRef(null);
    const listRef = useRef(null);
    const listRefGlobal = useRef(null);
    const [selectedData, setSelectedData] = useState(0)
    const [oldValue, setOldValue] = useState('');
    const [multipleOptions, setmultipleOptions] = useState([]);
    const [isItemSelected, setisItemSelected] = useState(false)
    const [initialSelectedItemIndex, setInitialSelectedItemIndex] = useState(-1);
    const [isFocused, setIsFocused] = useState(false)

    const handleOpenNewBrowserTab = useHandleOpenNewBrowserTab();
    const handleScroll = (index) => {
        const list = props.GlobalInst === true ? listRefGlobal.current : listRef.current;
        if (list) {
            const listItems = list.querySelectorAll('#ul-list-for-auto li');
            if (listItems && listItems[index]) {
                const selectedElement = listItems[index];
                // Use scrollIntoView to ensure the selected element is visible
                selectedElement.scrollIntoView({ block: 'nearest' });
            }
        }
    };
    useEffect(() => {
        // debugger
        const abortController = new AbortController();
        if (!isNull(props.searchValue)) {
            if (!isNull(props.data) && props.data.length > 0) {
                const initialIndex = props.data.findIndex((item) => {
                    let condition = false;
                    if (props?.DetailedView === "PatientEncounterAppt") {
                        condition = item.AppointmentDate === props.searchValue;
                    }
                    return item.value === props.searchValue || item.display === props.searchValue || condition;
                });
                if (initialIndex !== -1) {
                    handleScroll(initialIndex)
                    setInitialSelectedItemIndex(initialIndex);
                }
            }
            if (props.searchValue !== oldValue && props.is === false) {
                if (props.searchValue.length > 0) {
                    if (props.type === 'client') {
                        if (props.data !== undefined && props.data.length > 0) {
                            try {
                                let newList = [];
                                for (var i = 0; i < props.data.length; i++) {
                                    if (!isNull(props.data[i].display)) {
                                        if (props.filterWith) {
                                            if (props.filterWith === "startsWith") {
                                                if (props.data[i].display.startsWith(props.searchValue.toUpperCase())) {
                                                    newList = [...newList, props.data[i]];
                                                }
                                            }
                                        } else {
                                            let refinementDisplay = props.data[i].display.toLowerCase();

                                            if (refinementDisplay.includes(props.searchValue.toLowerCase())) {
                                                newList = [...newList, props.data[i]];
                                            }
                                        }
                                    }
                                }
                                setOptions(newList)
                                setNoResult(true)
                            } catch { }
                        }
                    }
                    else if (props.type === 'server') {
                        let response = '';
                        if (props.searchValue.length >= (props.searchValueMinChar || 2)) {
                            setIsLoading(prevLoading => { return true; });
                            (async () => {
                                try {
                                    if (props.method === "post") {
                                        // if postBody prop is not defined
                                        if (!props.postBody) {
                                            throw "Post Body prop is not defined"
                                        }
                                        else {
                                            response = await ServerRequestProtected(props.ApiLink, props.method, props.postBody, abortController.signal)
                                            setIsLoading(() => (false));
                                        }

                                    } else if (props.method === "get") {
                                        response = await ServerRequestProtected(`${props.ApiLink}${props.searchValue}`, props.method, null)
                                    }
                                    else {
                                        throw "Method not allowed";
                                    }
                                    if (response.hasOwnProperty('data')) {
                                        setOptions(response.data)
                                        if (response.data.length > 0) { setNoResult(true) } else { setNoResult(false) }
                                    } else {
                                        setOptions(response)
                                        if (response.length > 0) { setNoResult(true) } else { setNoResult(false) }
                                    }
                                } catch (error) {

                                    setIsLoading(() => (false));
                                    error.code === "ERR_CANCELED" ? setnoResponse(false) : setnoResponse(true)
                                    setNoResult(false)
                                    NotificationHandler(error, enumUtil.enumtoaster.warning)
                                }
                            })();
                        }

                        if (response !== undefined && response.length > 0) {
                            try {
                                let newList = [];
                                for (var i = 0; i < response.length; i++) {
                                    if (!isNull(response[i].ID)) {
                                        if (props.filterWith) {
                                            if (props.filterWith === "startsWith") {
                                                if (response[i].ID.startsWith(props.searchValue.toUpperCase())) {
                                                    newList = [...newList, response[i]];
                                                }
                                            }
                                        } else {
                                            let refinementDisplay = response[i].ID.toLowerCase();

                                            if (refinementDisplay.includes(props.searchValue.toLowerCase())) {
                                                newList = [...newList, response[i]];
                                            }
                                        }
                                    }
                                }
                                setOptions(newList)
                                setNoResult(true)
                            } catch { }
                        }
                    }
                }
            }
        } else {
            if (props.type === 'client') { }
            setOptions(props.data)
        }
        return () => { abortController.abort(); };
    }, [props.searchValue, isFocused]) // isFocused to scroll into view of the selected item 

    useEffect(() => {
        if (!listRefGlobal?.current || !(options?.length > 0)) return;
        const handleScroll = (e) => {
            if (!listRefGlobal.current.contains(e.target)) {
                e.preventDefault();
            }
        }
        if (isFocused) {
            // Disable scrolling on the body if target is outside list
            document.body.style.overflow = "hidden";
            document.addEventListener("wheel", handleScroll, { passive: false });
        } else {
            // Re-enable scrolling on the body
            document.body.style.overflow = "auto";
            document.removeEventListener("wheel", handleScroll);
        }
        // Cleanup on component unmount
        return () => {
            document.body.style.overflow = "auto";
            document.removeEventListener("wheel", handleScroll);
        };
    }, [options, isFocused])
    const handleChange = (e) => {
        setInitialSelectedItemIndex(0)
        setisItemSelected(false)
        setnoResponse(false)
        props.onChange(e)
        handleInputChange(e)
    }
    let counter = initialSelectedItemIndex != -1 ? initialSelectedItemIndex : 0; // to maintain the index 
    let bool;  // to check if the arrow is changed from down to up or from up to down (so we should inc or dec)
    let lastKeyPressed; // to check weather counter should be incremented or decremented

    const [isTabPressed, setIsTabPressed] = useState(false);
    const onKeyDownPressed = (e) => {
        if (e.keyCode === 40) {   // onDownkeyPress
            // debugger
            if (bool === false) {
                counter = counter + 2
            }
            handleScroll(counter);
            lastKeyPressed = e.keyCode
            if (options[counter] !== undefined) {
                if (counter <= options.length) {
                    const listItems = document.querySelectorAll('#ul-list-for-auto li');
                    listItems.forEach(function (item, index) {
                        if (index === counter) {
                            item.classList.add(styles.sup_DU);
                        } else {
                            item.classList.remove(styles.sup_DU);
                        }
                    });
                    counter = counter + 1
                    bool = true
                }
            }
        }
        if (e.keyCode === 38) {     // onUpkeyPress
            if (bool === true) {
                counter = counter - 2
            }
            handleScroll(counter);
            lastKeyPressed = e.keyCode
            if (options[counter] !== undefined) {
                if (counter <= options.length) {
                    const listItems = document.querySelectorAll('#ul-list-for-auto li');
                    listItems.forEach(function (item, index) {
                        if (index === counter) {
                            item.classList.add(styles.sup_DU);
                        } else {
                            item.classList.remove(styles.sup_DU);
                        }
                    });
                    counter = counter - 1
                }
                bool = false
            }
        }
        if (e.keyCode === 13) // User pressed the ENTER key
        {
            setisItemSelected(true)
            let index = counter;
            if (lastKeyPressed === 40) {
                index = index - 1  // onDownkeyPress
            } else if (lastKeyPressed === 38) {
                index = index + 1  // onUpkeyPress
            }
            if (options.length > 0) {
                props.getSelectedData(options[index], props.name, props.type)
                setOldValue(options[index].display)
                setNoResult(false)
                setOptions([])
            } else {
                handleonBlur(e)
            }
            // handleScroll(counter);
        }
        if (e.keyCode === 27) { // IF USER PRESSES ESC KEY THEN RESET THE COMPONENT TO ITS ORIGINAL STATE
            props.getSelectedData(null)
            setOptions([])
            setNoResult(!noResult)
            setSelectedData(0)
        }
        if (e.keyCode === 9) {
            // IF USER PRESSES THE TAB BUTTON
            setIsTabPressed(true);
            if (options && options?.length === 1) {
                handleSingleRow(options[0], 0)
            } else {
                handleonBlur();
            }
        }
    }
    let dispatch = useDispatch();
    let GenDD = useSelector(state => state.GeneralDropDownsReducer);


    const handleSingleRow = (singlerow, index, type, isGlobalSearch) => {
        // if (isGlobalSearch && singlerow.Type === 'Patient') {
        //     dispatch(GeneralDropDowns({
        //         ...GenDD, DisCardActiveIds: {
        //             ...GenDD?.DisCardActiveIds,
        //             Patient: [...GenDD?.DisCardActiveIds.Patient, {
        //                 isDemographicsOpened: false,
        //                 isDemographicsUpdated: false,
        //                 isInsuranceOpened: false,
        //                 isInsuranceUpdated: false,
        //                 PatientID: singlerow.Field1,
        //             }]
        //         }
        //     }))
        // }
        if (type === 'Rem') {
            props.getSelectedData(singlerow, props.name, props.type, props.mode) //props.name added to handle saveupdate
        } else if (props.mode === 'multiple') {
            if (!multipleOptions.includes(singlerow) && multipleOptions.length < 3) {
                const updatedList = [...multipleOptions, singlerow];
                setmultipleOptions(prevState => [...prevState, singlerow])
                props.getSelectedData(updatedList, props.name, props.type) //props.name added to handle saveupdate
            }
        } else {
            setOldValue(singlerow.display)
            props.getSelectedData(singlerow, props.name, props.type, props?.index, props?.recordID) //props.name added to handle saveupdate
        }
        setisItemSelected(true)
        setNoResult(false)
        setSelectedData(index)
        handleScroll(index);
    }
    const resetComponent = (e) => {
        props.getSelectedData(null, props.name, props.type)
        setOptions([])
        setNoResult(false)
    }
    const handleMouseDown = (e) => {
        if (isFocused) {
            inputRef.current.blur();
        } else {
            e.preventDefault();
            inputRef.current.focus();
        }
    }
    const handleOnClick = (e) => {
        // if (props.GlobalInst === true) { props.setIsFocused(true) }
        setisItemSelected(true);
        setIsFocused(!isFocused)
        if (!isNull(props.data)) {
            setOptions(props.data)
            setNoResult(!noResult)
            handleParentClick(e);
        } else {
        }
        if (props.handleonFocus) {
            props.handleonFocus()
        }
    }
    const handleOnFocus = (e) => {
        handleOnClick(e);
    }
    const handleonBlur = (e) => {
        setIsTabPressed(false);
        // if (props.GlobalInst === true) { props.setIsFocused(false) }
        setIsFocused(false)
        if (isTabPressed) {

        } else {
            if (!isNull(e)) {
                let { value, name } = e.target
                setNoResult(false)
                setnoResponse(false)
                if (props.handleOnblur) {
                    props.handleOnblur(value, name)
                }
                if (isItemSelected === false) {
                    props.getSelectedData(null, props.name, props.type)
                }
            }
        }
    }
    const handleRemoveItem = (index) => {
        const updatedLista = [...multipleOptions];
        updatedLista.splice(index, 1);
        setmultipleOptions(updatedLista);
        handleSingleRow(updatedLista, index, 'Rem')
    }
    const handleonBlurDiv = (e) => {
        if (!myDivRef.current.contains(e.relatedTarget)) {
            setIsFocused(false)
            setNoResult(false)
            setnoResponse(false)
        }
    }
    const handleSearch = () => {
        if (!isNull(props.handleOnClickSearch)) {
            props.handleOnClickSearch()
        }
    }
    const handleCommonKeyDown = (e) => {
        // Then, handle the common logic used for both the input and the div
        if (e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === "Enter") {
            onKeyDownPressed(e)
            e.preventDefault(); // Prevent default behavior for ArrowUp/ArrowDown/Enter
        }
    };
    const onMouseEnterHower = () => {
        const listItems = document.querySelectorAll('#ul-list-for-auto li');
        listItems.forEach(function (item, index) {
            item.classList.remove(styles.sup_DU);
        });
    }

    const handleOpenPatientsClaims = (e, data) => {
        e.stopPropagation();
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "All Claims",
                id: 0,
                time: new Date(),
                visitType: {
                    type: 'ClaimSearch',
                    PatientID: String(data.Field1),
                    PatientName: data.Field2,
                },
            },
        };
        setOpenTab(dataObj)
    }

    const handleonMouseChange = (e) => {
        setisItemSelected(true)
    }

    const [divStyle, setDivStyle] = useState({});
    const parentRef = useRef(null);

    // Positioning logic
    const updateDropdownPosition = () => {
        if (!parentRef.current || !listRef.current) return;

        const rect = parentRef.current.getBoundingClientRect();
        const dropdownHeight = listRef.current.offsetHeight;
        const dropdownWidth = listRef.current.offsetWidth;
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;

        let top = rect.bottom;
        let left = rect.left;

        // Adjust position if dropdown would go off bottom of screen
        if (rect.bottom + dropdownHeight > viewportHeight) {
            top = rect.top - dropdownHeight;
        }

        // Adjust position if dropdown would go off right of screen
        if (rect.left + dropdownWidth > viewportWidth) {
            left = viewportWidth - dropdownWidth - 10;
        }

        // Ensure dropdown doesn't go off left of screen
        if (left < 0) {
            left = 10;
        }

        setDivStyle({
            top: `${top}px`,
            left: `${left}px`,
            width: `${rect.width}px`,
            position: 'fixed',
            zIndex: 9999,
        });
    };

    // Call this whenever the dropdown should be positioned
    const positionDropdown = () => {
        if (props.ScrollOutside) {
            // Force reflow before updating position
            requestAnimationFrame(() => {
                updateDropdownPosition();
            });
        }
    };

    // Call this on parent div click
    const handleParentClick = (e) => {
        if (props.ScrollOutside) {
            positionDropdown();
        }
    };

    // Call this on input change
    const handleInputChange = (e) => {
        // Your existing filtering/search logic here...

        if (props.ScrollOutside) {
            positionDropdown();
        }
    };

    // Add resize and scroll listeners
    useEffect(() => {
        if (!props.ScrollOutside) return;

        const handleResize = () => {
            positionDropdown();
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('scroll', handleResize, true);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleResize);
        };
    }, [props.ScrollOutside]);

    const handleOpenClaimChild = (e, row) => {
        e.stopPropagation();
        let data = {
            name: 'Claims',
            data: {
                id: row.value,
                name: row.PatientName,
                VisitType: row.ClaimType,
                // ClaimRecord: claimRecord ,
                ClaimRecord: [],
            },
        };
        handleOpenNewBrowserTab(data)
    }

    return (
        <div id={`autoSuggestParentDiv_${props.id}`} className={`${styles.sup_auto_suggest} ${styles.insurance_auto} ${props.GlobalInst ? 'ar-input-width' : ''} `} style={{ width: `${props.width}` }} onClick={handleParentClick} ref={parentRef}>
            {multipleOptions.length > 0 ? <>
                {multipleOptions.map((item, index) => {
                    return (
                        <button class="btn btn-orange btn-xs no-width">{item.display} <i className="bi bi-x" onClick={() => handleRemoveItem(index)}></i></button>
                    )
                })}
            </> :
                null}
            <div className={`input-group flex-nowrap ${styles[props.sup_inp]}`}>
                {<input
                    ref={inputRef}
                    id={props.id}
                    name={props.name}
                    type="text"
                    autoComplete="off"
                    // className={`col ${styles.sup_yellowsearch}`}
                    className={props.inputError ? `col ${styles.sup_yellowsearch_error}` : `col ${styles.sup_yellowsearch}`}
                    // className="col"
                    placeholder={props?.placeholder === false ? "" : props?.placeholder}
                    onChange={handleChange}
                    value={props.searchValue}
                    onKeyDown={(e) => {
                        onKeyDownPressed(e);
                        // handleCommonKeyDown(e);
                    }}
                    onMouseDown={handleonMouseChange}
                    // onClick={handleOnClick}
                    onBlur={handleonBlur}
                    onFocus={handleOnFocus}
                    icon={true}
                    readOnly={props.isReadOnly || props.disableInput ? true : false}
                // disabled = {props.disableInput}
                />}
                {!props.disabled ? (
                    props.icon === true ?
                        <div className={`input-group-append ${styles.input_group_append}`} >
                            {props.searchValue ? (
                                <button onClick={resetComponent} className={`${styles.sup_btn_color} ${styles[props.sup_btn]}`}>
                                    <i className="bi bi-x" style={{ position: 'relative' }} />
                                </button>
                            ) : (
                                <button className={`${styles.sup_btn_color} ${styles[props.sup_btn]}`} onClick={handleSearch}>
                                    {' '}
                                    <i className="bi bi-search" style={{ position: 'relative' }} />
                                </button>
                            )}
                        </div>
                        :
                        props.icon === 'Simple' ?
                            <div
                                className="ar-search-arrow "
                                onMouseDown={handleMouseDown}
                                ref={myDivRef}
                                onBlur={handleonBlurDiv}
                                // onKeyDown={onKeyDownPressed}
                                onKeyDown={(e) => {
                                    // onKeyDownPressedForDiv(e);
                                    handleCommonKeyDown(e);
                                }}
                                tabIndex={1} // This makes the div focusable
                            >
                                {
                                    isFocused ? (
                                        <span className=""><i class="icon-caret-up fs-18"></i></span>
                                    ) : (
                                        <span className=""><i class="icon-caret-down fs-18"></i></span>
                                    )
                                }
                            </div>
                            :
                            <div className={`search-arrow ${styles.search_arrow}`}
                                onMouseDown={handleOnClick}
                                ref={myDivRef}
                                onBlur={handleonBlurDiv}
                                // onKeyDown={onKeyDownPressed}
                                onKeyDown={(e) => {
                                    // onKeyDownPressedForDiv(e);
                                    handleCommonKeyDown(e);
                                }}
                                tabIndex={0} // This makes the div focusable
                            >
                                {
                                    isFocused ? (
                                        <span className="dropdown_icon up"><i class="icon-caret-up"></i></span>
                                    ) : (
                                        <span className="dropdown_icon"><i class="icon-caret-down"></i></span>
                                    )
                                }
                            </div>

                ) : null}
            </div>
            {
                noResult ? (
                    // <div className={props.GlobalInst || props.PatientAppt ? `${styles.sup_listWrapper} ${styles.insurance_list_wrap} za-super-search-list rounded m-1` : `${styles.sup_listWrapper} ${styles.insurance_list_wrap} ${styles.ar_super_serach_multiple} hk-supListBOX`} ref={listRef}  >
                    <div className={props.GlobalInst || props.PatientAppt ? `${styles.sup_listWrapper} ${styles.insurance_list_wrap} za-super-search-list rounded m-1` : `${styles.sup_listWrapper} ${styles.insurance_list_wrap} ${styles.ar_super_serach_multiple} hk-supListBOX`} ref={listRef} style={!props.GlobalInst === true ? divStyle : null}>
                        {props.isReadOnly ? null :
                            <>
                                {props.GlobalInst === true ?
                                    <p className='za-super-head text font-m fst-italic fs-10 za-blue-clr'>{options?.length || '0'} Result(s) Found</p> : props.PatientAppt === true ? <p className='za-super-head text font-m fst-italic fs-10 za-blue-clr'>{options?.length - 1 || '0'} Result(s) Found</p> : props.InsuranceInst === true ? <p className='za-super-head text font-m fst-italic fs-10 za-blue-clr px-1-5 br-bottom-1 py-1 za_br_light'>{options?.length || '0'} Result(s) Found</p> : <></>}
                                <ul className={`${(props.GlobalInst || props.PatientAppt) ? 'za-super-search-cards hover-scrollbar ps-0 mb-0' : 'list-group hover-scrollbar '}`} id="ul-list-for-auto" ref={listRefGlobal}>
                                    {options && options.map((item, index) => {
                                        const patients = item?.PatientDataJson ? JSON.parse(item.PatientDataJson) : [];
                                        return (<>
                                            {
                                                <div className={`${styles.ar_options_list} ${['True', 'true', true].includes(item?.IsDisable) ? "pe-none user-select-none" : ''}`}>
                                                    <li className={`${styles.sup_list_group_item} ${index === initialSelectedItemIndex ? styles.sup_DU + ' ' + styles.ar_slected_list : ''}`}
                                                        key={index}
                                                        onMouseDown={() => handleSingleRow(options[index], index)}
                                                        onMouseEnter={onMouseEnterHower}
                                                        id={index}
                                                    >
                                                        {props.Color === true ? <span className={item.color}></span> : null}
                                                        {props?.AppointmentStatus ?
                                                            <div className={`${styles.ar_all_options + " " + item?.ColorCode.replace('#', 'color-')}`}>
                                                                {item.value === -1 ? 'Select Type' : item.display}
                                                            </div> :
                                                            props?.IsCLMInsurance ?
                                                                <div className={`${styles.ar_all_options} text  ${item.Active === 'false' ? styles.ar_red_insurance : null}`}>
                                                                    {item.value === -1 ? 'Select Type' : item.CoveragePriority === 'P' ? `${'PRI - ' + item.display}` :
                                                                        item.CoveragePriority === 'S' ? `${'SEC - ' + item.display}` :
                                                                            item.CoveragePriority === 'T' ? `${'TER - ' + item.display}` : `${item.display}`
                                                                    }
                                                                </div> :
                                                                props.InsuranceInst ?
                                                                    null :
                                                                    props.DetailedView === "PatientPastEncounter" ?
                                                                        (
                                                                            <>
                                                                                {(index === 0 && [-1, '-1', ''].includes(item.value)) ?
                                                                                    <div className={`${styles.ar_all_options}`}></div>
                                                                                    :
                                                                                    <div className={`${styles.ar_all_options}`}>
                                                                                        <div className="d-flex align-items-center justify-content-between">
                                                                                            <p className='heading font-m'>{item?.display}
                                                                                                {item?.AppointmentStart ? `- ${item?.AppointmentStart}` : ''}
                                                                                            </p>
                                                                                            {item?.EncounterStatus ?
                                                                                                <p className={`pill font-m ${item.EncounterStatus === 'Signed' ? 'Paid' : item.EncounterStatus === 'In Progress' ? 'Blue-Status' : item.EncounterStatus === 'Ready for Review' ? 'In-Review' : 'Not-Signed'} `}>{item?.EncounterStatus}</p>
                                                                                                : <></>}

                                                                                        </div>
                                                                                        <div className="d-flex align-items-center gap-5">
                                                                                            <p className='text fs-11'>Note Type:</p>
                                                                                            <p className='fs-11 text text-nowrap validation_message'>{item?.NoteType}</p>
                                                                                        </div>
                                                                                        <div className="d-flex align-items-center gap-5">
                                                                                            <p className='text fs-11'>CC:</p>
                                                                                            <p className='fs-11 text text-nowrap validation_message'>{item?.ChiefComplaint || 'N/A'}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                }

                                                                            </>
                                                                        )
                                                                        :
                                                                        props.DetailedView === "LinkClaim" ?
                                                                            (
                                                                                <>
                                                                                    <div className={`${styles.ar_all_options}`}>
                                                                                        <div className="d-flex align-items-cnter justify-content-between">
                                                                                            <div className="d-flex align-items-center gap-01 pb-2px">
                                                                                                <p className='text font-m'><span className="font-sb">Claim # </span>{item.value} </p>
                                                                                                <i className="fs-16 icon-enrollment lh-12" onMouseDown={(e) => handleOpenClaimChild(e, item)}></i>
                                                                                                <p className={`heading fs-11 text-bg-M d-flex justify-content-center align-items-center lh-11 ${false === "I" ? 'Institutional-bg' : ''}`}>{item.ClaimType}</p>
                                                                                            </div>
                                                                                            <HandleStatus Status={item.BillingStatus} />
                                                                                        </div>
                                                                                        <p className='text fst-italic ar-dark-color font-m'>{item.Insurance}</p>
                                                                                    </div>
                                                                                </>
                                                                            )
                                                                            :
                                                                            props.DetailedView === "PatientEncounterApptGroup" ?
                                                                                (
                                                                                    <div className={`${styles.ar_all_options} ${['True', 'true', true].includes(item?.IsDisable) ? "ar_disable_appontment" : ''}`}>
                                                                                        {[-1, '-1'].includes(item?.value) ? <></> :
                                                                                            <div className="d-flex flex-column gap-1">
                                                                                                <div className="d-flex align-items-center justify-content-between">
                                                                                                    <p className='heading font-m'>{item?.AppointmentDate} {item?.AppointmentStart ? `- ${item?.AppointmentStart}` : ''}</p>
                                                                                                    <p className={`pill ${String(item?.Status).replace(' ', '-')}`}>{item?.Status}</p>
                                                                                                </div>
                                                                                                
                                                                                                <div className="d-flex align-items-center gap-5" key={index}>
                                                                                                    <p className='text fs-11'>Participants:</p>
                                                                                                    
                                                                                                    <p className='fs-11 text text-nowrap validation_message'>{patients[0]?.PatientName} 
                                                                                                        <span className="font-m">{patients?.length > 1 && ` +${patients.length - 1} more`}</span>
                                                                                                    </p>
                                                                                                </div>

                                                                                                <div className="d-flex align-items-center gap-5">
                                                                                                    <p className='text fs-11 text-nowrap'>Group Name:</p>
                                                                                                    <p className='fs-11 text text-nowrap validation_message'>{item?.GroupName}</p>
                                                                                                </div>
                                                                                            </div>}
                                                                                    </div>
                                                                                )
                                                                                :
                                                                                (
                                                                                    <>
                                                                                        {/* <div className={`${styles.ar_all_options} text d-flex justify-content-between align-items-center `}>
                                                                                 <span>{item.value === -1 ? 'Select Type' : item.display}</span>
                                                                                 {!isNull(item.ColorCode) ? <div className='ar_chekbox-circle me-0' style={{ backgroundColor: item?.ColorCode }}></div> : null}
                                                                             </div> */}

                                                                                        <div className={`${styles.ar_all_options} ${['True', 'true', true].includes(item?.IsDisable) ? "ar_disable_appontment" : ''}`}>
                                                                                            {[-1, '-1'].includes(item?.value) ? <></> :
                                                                                                <>
                                                                                                    <div className="d-flex align-items-center justify-content-between">
                                                                                                        <p className='heading font-m'>{item?.AppointmentDate} {item?.AppointmentStart ? `- ${item?.AppointmentStart}` : ''}</p>
                                                                                                        <p className={`pill ${String(item?.Status).replace(' ', '-')}`}>{item?.Status}</p>
                                                                                                    </div>
                                                                                                    <div className="d-flex align-items-center gap-5">
                                                                                                        <p className='text fs-11'>CC:</p>
                                                                                                        <p className='fs-11 text text-nowrap validation_message'>{item?.ChiefComplain}</p>
                                                                                                    </div>
                                                                                                </>}
                                                                                        </div>
                                                                                    </>
                                                                                )}

                                                        {/* <div className="d-flex align-items-center justify-content-between">
                                                                <p className='heading font-m'>{item?.AppointmentDate} {item?.AppointmentStart ? `- ${item?.AppointmentStart}`: ''}</p>
                                                                <p className={`pill ${String(item?.Status).replace(' ', '-')}`}>{item?.Status}</p>
                                                              </div>
                                                              <div className="d-flex align-items-center gap-5">
                                                                <p className='text fs-11'>CC:</p>
                                                                <p className='fs-11 text text-nowrap validation_message'>{item?.ChiefComplain}</p>
                                                              </div> */}

                                                    </li>
                                                </div>

                                            }
                                        </>)
                                    })}
                                </ul>
                            </>
                        }
                    </div>
                ) : null
            }
            {noResponse === true ?
                <div className={`${styles.sup_listWrapper} ${styles.insurance_list_wrap} hk-supListBOX`}>
                    <div className="list-group" id="ul-list-for-auto">
                        <p className={styles.sup_list_group_item} >No Data Found !</p>
                    </div>
                </div>
                : null}
        </div>
    )
}

export default React.memo(SuperSearchSingleClient);